var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpowerment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 261.61,
    height: 261.61,
    viewBox: "0 0 261.61 261.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.925,
    y1: 0.925,
    x2: 0.075,
    y2: 0.075,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#6154c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ea74"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_62",
    x: 0,
    y: 0,
    width: 261.61,
    height: 261.61,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.11,
    dy: 6.11,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.182,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.066,
    y1: 0.327,
    x2: 1.068,
    y2: 0.674,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empowerment",
    transform: "translate(-1171.28 -5344.617)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1171.28, 5344.62)",
    filter: "url(#Rectangle_62)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62-2",
    "data-name": "Rectangle 62",
    width: 248.517,
    height: 248.517,
    rx: 63.606,
    transform: "translate(0.44 0.44)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M1258.944,5477.5c-.006.078-.315,1.032-.346,1.13Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M1352.694,5539.876c-2.906,3.6-6.52,16.5-13.341,12.264l-25.87-15.1a5.339,5.339,0,0,1-1.919-7.3c2.906-3.6,6.52-16.5,13.341-12.263l25.87,15.1A5.338,5.338,0,0,1,1352.694,5539.876Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M1377.644,5445.465c5.919,2.464,1.341,17.134,1.752,21.648-1.193,7.7,1.008,16.565-2.657,23.528q-8.436,14.607-16.927,29.168c-2.524,3.056-4.388,12.031-10.157,9.223l-18.267-10.665c-5.393-2.959,1.771-10.267,3.133-13.555.119-.387,16.318-27.7,16.982-29.033,3.173-6.047,12.553-3.825,12.132,2.971C1370.193,5472.336,1361.248,5439.423,1377.644,5445.465Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M1239.255,5539.876c2.906,3.6,6.52,16.5,13.341,12.264l25.87-15.1a5.338,5.338,0,0,0,1.919-7.3c-2.906-3.6-6.519-16.5-13.341-12.263l-25.87,15.1A5.338,5.338,0,0,0,1239.255,5539.876Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M1214.305,5445.465c-5.918,2.464-1.341,17.134-1.752,21.648,1.193,7.7-1.008,16.565,2.657,23.528q8.436,14.607,16.927,29.168c2.524,3.056,4.389,12.031,10.158,9.223l18.266-10.665c5.393-2.959-1.771-10.267-3.133-13.555-.119-.387-16.318-27.7-16.982-29.033-3.173-6.047-12.553-3.825-12.132,2.971C1221.756,5472.336,1230.7,5439.423,1214.305,5445.465Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M1329.928,5424.779l-36.163,59.186a3.879,3.879,0,0,1-7.183-2.249l1.691-28.9a3.879,3.879,0,0,0-3.872-4.106h-13.4a3.878,3.878,0,0,1-3.862-4.239l5.12-54.894a3.88,3.88,0,0,1,3.863-3.519h38.632a3.879,3.879,0,0,1,3.586,5.359l-9.124,22.1a3.878,3.878,0,0,0,3.585,5.359h13.812A3.879,3.879,0,0,1,1329.928,5424.779Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpowerment);
export default __webpack_public_path__ + "static/media/Empowerment.7f5ea190676b573e0f92e2e427d6728b.svg";
export { ForwardRef as ReactComponent };